import Link from "next/link";

import Image from "next/image";
import { motion } from "motion/react";
export function SM_Header() {
  return (
    // Top navigation
    <header className="w-full py-6 px-6 bg-white shadow-sm z-10">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link href="/" className="flex items-center gap-2">
          <motion.div
            whileHover={{ scale: 1.05, rotate: 3 }}
            whileTap={{ scale: 0.95, rotate: -3 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
            className="h-15 w-50 rounded-full overflow-hidden flex items-center justify-center shadow-sm"
          >
            <Image
              src="/logo.svg"
              alt="Inde Menu"
              width={110}
              height={110}
              className="object-contain"
            />
          </motion.div>
        </Link>
        <div className="hidden sm:flex items-center gap-6">
          <Link
            href="/vendors"
            className="text-[#7B7B7B] hover:text-[#2F4858] transition-colors"
          >
            Restaurants
          </Link>
          <Link
            href="/how-it-works"
            className="text-[#7B7B7B] hover:text-[#2F4858] transition-colors"
          >
            How It Works
          </Link>
        </div>
      </div>
    </header>
  );
}